<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="btnPermission.search" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="编号：">
					<el-input v-model="formInline.code" placeholder="请输入申购单编号" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="申请时间：">
					<el-date-picker
						v-model="dateRange"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy年MM月dd日"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="申购类型：">
					<el-select v-model="formInline.state" placeholder="请选择申购类型" clearable size="small" filterable @change="search">
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId">
				<el-table-column slot="mainInfo.code" label="申购单编号" min-width="220" align="center">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleDetailClick(scope.row)">
							{{ scope.row.mainInfo.code }}
						</el-link>
					</template>
				</el-table-column>
				<template #stateStr>
					<el-table-column label="申购状态" min-width="140" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.state == 1" type="info">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 2" type="primary">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 8" type="danger">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 3" type="info">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 4" type="warning">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else type="success">{{ scope.row.stateStr }}</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" min-width="170" align="center" fixed="right">
						<template #default="scope">
						<div class="lcsj-row-actions"><button class="lcsj-row-actions__link" v-if="scope.row.state == 1 && btnPermission.storeKuaiDi" @click="handleStoreKuaiDiClick(scope.row)">门店快递</button>
							<button class="lcsj-row-actions__link" v-if="scope.row.state == 2 && btnPermission.purchaseReceive" @click="handlePurchaseReceiveClick(scope.row)">
							采购部接收
							</button>
							<button class="lcsj-row-actions__link" v-if="scope.row.state == 3 && btnPermission.purchaseKuaiDi" @click="handlePurchaseKuaiDiClick(scope.row)">
							采购部快递
							</button>
							<button class="lcsj-row-actions__link" v-if="scope.row.state == 4 && btnPermission.receive" @click="handleStoreReceiveClick(scope.row)">接收</button>
						</div>
					</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 详情 -->
		<detail ref="detail" :store-list="storeList"></detail>

		<!-- 录入快递单号 -->
		<lcsj-dialog v-model="dialogEditKDNoVisible" title="录入快递单号" width="720px" cancel-text="取消" confirm-text="确认"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleEditKDNoClick"> <span style="display: block; margin-bottom: 10px"><strong>快递单号:</strong></span>
			<el-input clearable v-model="editKDInfo.kdNo" placeholder="请输入快递单号"></el-input>
			<span v-if="type == 2" style="display: block; margin-bottom: 10px"><strong>快递费用:</strong></span>
			<el-input v-if="type == 2" v-model.number="editKDInfo.shippingCost" type="number" min="0" max="9999999999" step="0.01" precision="2" placeholder="请输入快递费用"></el-input></lcsj-dialog>
	</div>
</template>

<script>
import { GetStoreSubscriptionReturnageList, StoreSendKuaiDi, PurchaseExchange, PurchaseSendKuaiDi, StoreReceiveProduct } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "@/views/product/subscription/detail.vue";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "退货明细"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				state: 0,
				code: "",
				startTime: null,
				endTime: null
			},
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "退货时间",
					width: "170",
					align: "center",
				},
				{
					prop: "creator",
					label: "退货人",
					width: "120",
					align: "center",
				},
				{
					prop: "mainInfo.storeName",
					label: "所属门店",
					width: "120",
					align: "center",
				},
				{
					slot: "stateStr",
					label: "退货状态",
					width: "120",
					align: "center",
				},
				{
					slot: "mainInfo.code",
					label: "申购单编号",
					width: "220",
					align: "center"
				},
				{
					prop: "productTypeInfo.typeName",
					label: "类型",
					width: "120",
					align: "center"
				},
				{
					prop: "productTypeInfo.productName",
					label: "系列",
					width: "120",
					align: "center"
				},
				{
					prop: "productTypeInfo.specification",
					label: "商品名称",
					width: "220",
					align: "center"
				},
				{
					prop: "productBrand",
					label: "商品品牌",
					width: "220",
					align: "center"
				},
				{
					prop: "quantity",
					label: "退货数量",
					width: "100",
					align: "center"
				},
				{
					prop: "productTypeInfo.unit",
					label: "单位",
					width: "80",
					align: "center"
				},
				{
					prop: "storeKDNo",
					label: "门店快递单号",
					width: "180",
					align: "center"
				},
				// {
				//     prop: "shippingCost",
				//     label: "门店运费",
				//     width: "80",
				//     align: "center",
				// },
				{
					prop: "purchaseKDNo",
					label: "加工部快递单号",
					width: "180",
					align: "center"
				},
				{
					prop: "purchaseShippingCost",
					label: "加工部运费",
					width: "90",
					align: "center"
				},
				{
					prop: "reason",
					label: "退货原因",
					width: "220",
					align: "center"
				},
				{
					prop: "remark",
					label: "备注",
					width: "220",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "170",
					align: "center"
				}
			],
			storeList: [],
			stateList: [],
			dateRange: [],
			btnPermission: {
				search: false,
				storeKuaiDi: false,
				purchaseKuaiDi: false,
				purchaseReceive: false,
				receive: false
			},
			// 录入快递单号
			editKDInfo: {
				kdNo: "",
				keyId: "",
				shippingCost: 0
			},
			dialogEditKDNoVisible: false,
			type: 1 //1:门店快递 2:加工部快递
		};
	},
	// 注册组件
	components: {
		detail
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
		this.getListData();
		// 按钮权限
		this.btnPermission = {
			search: this.$checkBtnPermission("/subscriptionReturn/main", "viewPage"),
			storeKuaiDi: this.$checkBtnPermission("/subscriptionReturn/main", "storeKuaiDi"),
			purchaseKuaiDi: this.$checkBtnPermission("/subscriptionReturn/main", "purchaseKuaiDi"),
			purchaseReceive: this.$checkBtnPermission("/subscriptionReturn/main", "purchaseReceive"),
			receive: this.$checkBtnPermission("/subscriptionReturn/main", "receive")
		};
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreSubscriptionReturnageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "SubscriptionReturnState"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 门店选择事件
		handleStoreChange(val) {
			this.formInline.storeKeyId = val;
			this.search();
		},
		// 详情
		handleDetailClick(row) {
			this.$refs.detail.showDetail(row.mainInfo.keyId, 1);
		},
		// 门店快递
		handleStoreKuaiDiClick(row) {
			this.editKDInfo.keyId = row.keyId;
			this.type = 1;
			this.dialogEditKDNoVisible = true;
			this.editKDInfo.shippingCost = 0;
			this.editKDInfo.kdNo = "";
		},
		// 加工部快递
		handlePurchaseKuaiDiClick(row) {
			this.editKDInfo.keyId = row.keyId;
			this.type = 2;
			this.dialogEditKDNoVisible = true;
			this.editKDInfo.shippingCost = 0;
			this.editKDInfo.kdNo = "";
		},
		// 编辑快递单号
		handleEditKDNoClick() {
			if (!this.editKDInfo.kdNo) {
				this.$message.error("请输入快递单号！");
				return;
			}
			this.$confirm("确认录入快递单号吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				if (this.type == 1) {
					StoreSendKuaiDi({
						keyId: this.editKDInfo.keyId,
						kdNo: this.editKDInfo.kdNo
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "门店快递单号更新成功！"
								});
								this.dialogEditKDNoVisible = false;
								this.search();
							} else {
								this.$message.error(res.msg);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					PurchaseSendKuaiDi({
						keyId: this.editKDInfo.keyId,
						kdNo: this.editKDInfo.kdNo,
						shippingCost: this.editKDInfo.shippingCost
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "加工部快递单号更新成功！"
								});
								this.dialogEditKDNoVisible = false;
								this.search();
							} else {
								this.$message.error(res.msg);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		},
		// 采购部接收
		handlePurchaseReceiveClick(row) {
			this.$confirm("确认采购部接收吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				PurchaseExchange({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "采购部接收成功！"
							});
							this.search();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		// 门店接收
		handleStoreReceiveClick(row) {
			this.$confirm("确认门店接收吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				StoreReceiveProduct({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "门店接收成功！"
							});
							this.search();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>

<style scoped>/* 行内操作文字链（由表格操作列改造脚本注入） */
.lcsj-row-actions {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	white-space: nowrap;
}

.lcsj-row-actions__link {
	color: var(--app-primary-text);
	cursor: pointer;
	font-size: var(--app-font-base);
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	line-height: 1.6;
}

.lcsj-row-actions__link:hover {
	text-decoration: underline;
}

.lcsj-row-actions__link--danger {
	color: var(--app-danger-text);
}
</style>
